import { Observable, BehaviorSubject } from 'rxjs';
// export for convenience.
export {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet
} from '@angular/router';

import {
  Component,
  Directive,
  Injectable,
  Input,
  NgModule
} from '@angular/core';
import { NavigationExtras } from '@angular/router';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[routerLink]',
    // eslint-disable-next-line
    host: {
        '(click)': 'onClick()'
    },
    standalone: true
})
export class RouterLinkStubDirective {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('routerLink') linkParams: any;
  navigatedTo: any = null;

  onClick() {
    this.navigatedTo = this.linkParams;
  }
}

// eslint-disable-next-line @angular-eslint/component-selector
@Component({
    selector: 'router-outlet', template: '',
    standalone: true
})
export class RouterOutletStubComponent {}

@Injectable()
export class RouterStub {
  navigate(commands: any[], extras?: NavigationExtras) {}
}
import { convertToParamMap, ParamMap } from '@angular/router';

@Injectable()
export class ActivatedRouteStub {
  // ActivatedRoute.paramMap is Observable
  private subject = new BehaviorSubject(
    this.testParamMap ? convertToParamMap(this.testParamMap) : null
  );
  paramMap = this.subject.asObservable();
  data: Observable<{ [name: string]: any }> | null = null;
  // Test parameters
  private _testParamMap: ParamMap | null = null;
  get testParamMap() {
    return this._testParamMap;
  }
  set testParamMap(params: {} | null) {
    if (params !== null) {
      this._testParamMap = convertToParamMap(params);
      this.subject.next(this._testParamMap);
    }
  }

  // ActivatedRoute.snapshot.paramMap
  get snapshot() {
    return { paramMap: this.testParamMap };
  }
}

/**
 * Needed so that `aot` build is working. But it isn't used throughout our tests and/or app.
 */

